/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react';
import { Label } from 'components/atoms';
import { Row } from 'components/atoms/_util';
import { KYC_PERSONAL_INFO_SCHEMA } from 'util/schemas';
import { DropdownInput, Form, Input } from 'components/atoms/_common';
import { useKYCUpdateStepperContext } from 'context/KYCUpdateStepper';

import USStates from 'components/atoms/_common/DropdownInput/renderers/USStatesItem/us-states-data.mock';
import USStatesItem from 'components/atoms/_common/DropdownInput/renderers/USStatesItem/styles';
import usePersonalInfoGateway from 'pages/public/KYCUpdate/usePersonalInfoGateway';

const USCountry: React.FC = () => {
  const { isLoadingInfo } = usePersonalInfoGateway();
  const { personalInformation, nextStep, setPersonalInformation } =
    useKYCUpdateStepperContext();

  const handleSubmit = values => {
    setPersonalInformation(values);
    nextStep();
  };

  if (isLoadingInfo) {
    return <div>Getting your information, please wait...</div>;
  }

  return (
    <Form
      onSubmit={handleSubmit}
      defaultValues={personalInformation}
      schema={KYC_PERSONAL_INFO_SCHEMA}
    >
      <Label text="Personal details" iconName="person" />
      <Row breakRowOnMobile>
        <Input name="firstName" label="First name" placeholder="First name" />
        <Input
          optional
          name="middleName"
          label="Middle name"
          placeholder="Middle name"
        />
        <Input name="lastName" label="Last name" placeholder="Last name" />
        <Input
          type="date"
          name="dateOfBirth"
          label="Date of Birth"
          placeholder="Date of Birth"
        />
      </Row>

      <Label text="Address" iconName="pin_drop" />
      <Row breakRowOnMobile>
        <Input
          name="houseNumber"
          label="House number"
          placeholder="House number"
        />
        <Input
          name="streetName"
          label="Street name"
          placeholder="Street name"
        />
        <Input
          name="streetType"
          label="Street type"
          placeholder="Street type"
        />
        <Input
          optional
          name="unitApNumber"
          label="Unit or apartment number"
          placeholder="Unit or apartment number"
        />
      </Row>

      <Row breakRowOnMobile>
        <Input name="city" label="City" placeholder="City" />
        {/* prettier-ignore */}
        <DropdownInput
            name="state"
            label="State"
            hint="Select your state"
            items={USStates}
            itemRenderer={({ item, onItemClick }) => (
              <USStatesItem onClick={() => onItemClick(item.id)}>
                <span className="state-id">{item.id}</span>
                <span className="state-name">{item.name}</span>
              </USStatesItem>
            )}
          />
        <Input
          name="zipCode"
          label="Zip code"
          placeholder="Zip code"
          maxLength={5}
        />
      </Row>

      <Label text="Government ID Number" iconName="description" />
      <Row>
        <Input
          mask="999-99-9999"
          name="governmentId"
          label="Government ID Number"
          placeholder="Example: SSN"
        />
      </Row>

      <button type="submit" className="submit-kyc" />
    </Form>
  );
};
export default USCountry;
